// extracted by mini-css-extract-plugin
export default {"root":"_6aPADfuyjDLWB-KOsy3G7Q==","header":"mo7Bs5eZfjh7Kuoc1E9E2A==","body":"SdtFBL6oaDeGVgoRzysXTw==","icon":"F+6WPxgycYDDtXMoDl2s9A==","description":"GX+W-7nPbsv3VrXFfFteWQ=="};